import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { PayButton } from '../../../PayButton';

const CURRENCIES = ['USD', 'EUR', 'RUB', 'KZT'];
const PAYMENT_URL = 'https://auth.robokassa.ru/Merchant/Index.aspx';

const propTypes = {
    merchantLogin: PropTypes.string.isRequired,
    invId: PropTypes.string.isRequired,
    outSum: PropTypes.number.isRequired,
    outSumCurrency: PropTypes.oneOf(CURRENCIES),
    createSignature: PropTypes.func.isRequired,
    isTest: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
};

const defaultProps = {
    outSumCurrency: 'RUB',
    isTest: false,
};

function RobokassaButton({
    merchantLogin,
    invId,
    outSum,
    outSumCurrency,
    createSignature,
    disabled: rawDisabled,
    isTest,
}) {
    const [signature, setSignature] = useState('');
    const [disabled, setDisabled] = useState(true);
    const isDisabled = disabled || rawDisabled;

    useEffect(() => {
        async function request() {
            setDisabled(true);

            try {
                const json = await createSignature({});

                setSignature(json.signature);
            } finally {
                setDisabled(false);
            }
        }
        void request();
    }, []);

    return (
        <form method="POST" action={PAYMENT_URL}>
            <input type="hidden" name="MerchantLogin" value={merchantLogin} />
            <input type="hidden" name="InvId" value={invId} />
            <input type="hidden" name="SignatureValue" value={signature} />
            <input type="hidden" name="OutSum" value={outSum} />
            <input type="hidden" name="OutSumCurrency" value={outSumCurrency} />
            {isTest && <input type="hidden" name="IsTest" value="1" />}

            <PayButton disabled={isDisabled} provider="robokassa" />
        </form>
    );
}

RobokassaButton.propTypes = propTypes;
RobokassaButton.defaultProps = defaultProps;

export default RobokassaButton;
